import { render } from "./PlayerPicker.vue?vue&type=template&id=495b457c"
import script from "./PlayerPicker.vue?vue&type=script&lang=js"
export * from "./PlayerPicker.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__